/**
 * Query used to get RFX user business ID
 * Below are the list of services that it talks to:
 * AWSSCMRFXService
 */
import { gql } from '@apollo/client';

import { NullableStringArray } from "../../interfaces";
import { processResponse } from "./helper";

export interface GetUserBusinessQueryResultType {
  getRFXUserBusiness: {
    businessIdList: NullableStringArray
  }
};

export const getRFXUserBusinessQuery = gql`
  query getRFXUserBusiness{
    getRFXUserBusiness{
      businessIdList
    }
  }
`;

export default function getRFXUserBusiness(this: any) {
  return processResponse(this.query({
    query: getRFXUserBusinessQuery,
  }), "getRFXUserBusiness"
  );
}
